/* eslint-disable import/prefer-default-export */
import {
  humps,
  message,
  notificationService,
  useAppSelector,
  useTranslation,
} from '@lib/index';
import { useEffect, useState } from 'react';
import { NotificationProps } from './types';

export const useNotificationActions = () => {
  const { t } = useTranslation();
  const { currentUser } = useAppSelector((state) => state.account);
  const [open, setOpen] = useState(false);

  const { useGetNotificationsQuery, useUpdateNotificationMutation } = notificationService;
  const [updateNotification] = useUpdateNotificationMutation();
  const [localNotifications, setLocalNotifications] = useState<NotificationProps[]>([]);

  const {
    data: notificationsData,
    isFetching,
    refetch,
    isLoading: isLoadingNotifications,
  } = useGetNotificationsQuery();

  useEffect(() => {
    if (!notificationsData || isFetching) return;

    const flat = Array.isArray(notificationsData) ? notificationsData.flat() : [];
    const unique = flat.filter((n, i, self) => self.findIndex((m) => m.id === n.id) === i);
    setLocalNotifications(humps(unique) as NotificationProps[]);
  }, [notificationsData, isFetching]);

  useEffect(() => {
    if (currentUser) {
      setLocalNotifications([]);
      refetch();
      setOpen(true);
    }
  }, [currentUser, refetch]);

  const handleSeenNotification = async (notification: { id: number; seen: boolean }) => {
    try {
      await updateNotification(notification).unwrap();
      setLocalNotifications((prev) => prev.map(
        (n) => (n.id === notification.id ? { ...n, seen: true } : n),
      ));
    } catch {
      message.error(t('contractor.updateError'), 2);
    }
  };

  return {
    notifications: localNotifications,
    handleSeenNotification,
    isLoadingNotifications,
    open,
    setOpen,
  };
};
